import { useMemo } from 'react';
import { Table } from 'antd';
import type { CSSProperties } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { EXPAND_COLUMN_WIDTH } from '../list/inventoryListStyled';
import {
  renderReplenishmentLotCell,
  type ReplenishmentListCellContext,
} from './replenishmentListCells';
import {
  buildReplenishmentLotRows,
  getReplenishmentLotRowKey,
  type ReplenishmentColumnKey,
  type ReplenishmentItem,
  type ReplenishmentLotRow,
} from './replenishmentListTypes';

const CELL_STYLE: CSSProperties = {
  verticalAlign: 'top',
  background: '#FAFAFA',
};

const ACTIONS_CELL_STYLE: CSSProperties = {
  ...CELL_STYLE,
  verticalAlign: 'middle',
};

const COLUMN_DEFS: { key: ReplenishmentColumnKey; width: string }[] = [
  { key: 'description', width: '25%' },
  { key: 'organization', width: '22%' },
  { key: 'location', width: '22%' },
  { key: 'quantity_remaining', width: '12%' },
  { key: 'actions', width: '19%' },
];

type ReplenishmentLotSubTableProps = {
  item: ReplenishmentItem;
  cellCtx: ReplenishmentListCellContext;
};

export function ReplenishmentLotSubTable({
  item,
  cellCtx,
}: ReplenishmentLotSubTableProps) {
  const lotRows = useMemo(() => buildReplenishmentLotRows(item), [item]);

  const columns: ColumnsType<ReplenishmentLotRow> = useMemo(
    () => [
      {
        key: 'expand-spacer',
        width: EXPAND_COLUMN_WIDTH,
        render: () => null,
      },
      ...COLUMN_DEFS.map(col => ({
        key: col.key,
        width: col.width,
        onCell: () => ({
          style: col.key === 'actions' ? ACTIONS_CELL_STYLE : CELL_STYLE,
        }),
        render: (_: unknown, record: ReplenishmentLotRow) =>
          renderReplenishmentLotCell(col.key, record, cellCtx),
      })),
    ],
    [cellCtx],
  );

  return (
    <Table<ReplenishmentLotRow>
      className="inventory-list-lot-table"
      rowKey={getReplenishmentLotRowKey}
      columns={columns}
      dataSource={lotRows}
      pagination={false}
      showHeader={false}
      size="middle"
      tableLayout="fixed"
    />
  );
}
